module.exports = __webpack_public_path__ + "static/3-a66b0fb302d0af54626d51f4b6a597c2.jpg";